// Left rail of the Reports page: built-in templates first, then the
// user's saved reports. Selected entry is highlighted. Phase 1: pure
// list — no rename/delete/duplicate (those land in Phase 2).

import { I } from '../icons.jsx';

function Section({ title, items, selectedId, onSelect, emptyText }) {
  return (
    <div className="report-sidebar-section">
      <div className="report-sidebar-section-title">{title}</div>
      {items.length === 0 ? (
        <div className="report-sidebar-empty">{emptyText}</div>
      ) : (
        <ul className="report-sidebar-list">
          {items.map(r => (
            <li key={r.id}>
              <button
                type="button"
                className={'report-sidebar-item' + (r.id === selectedId ? ' active' : '')}
                onClick={() => onSelect(r.id)}
              >
                <I.Reports size={14} />
                <span className="report-sidebar-name">{r.name}</span>
                {r.builtin && <span className="pill cyan report-sidebar-tag">Built-in</span>}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export function ReportSidebar({ reports, selectedId, onSelect }) {
  const builtin = reports.filter(r => r.builtin);
  const user    = reports.filter(r => !r.builtin);
  return (
    <aside className="report-sidebar">
      <Section
        title="Built-in"
        items={builtin}
        selectedId={selectedId}
        onSelect={onSelect}
        emptyText="No built-ins"
      />
      <Section
        title="Your reports"
        items={user}
        selectedId={selectedId}
        onSelect={onSelect}
        emptyText="None yet — duplicate a built-in to start (Phase 2)"
      />
    </aside>
  );
}
